import React from 'react'
import { useState } from 'react'
import MyModal from '../../../../UI/modal/MyModal'
import ValueWithEdit from '../../../../UI/table/values/ValueWithEdit'
import ChangeNameInBillForm from './ChangeNameInBillForm'

const ChangeNameInBillButton = ({ supplyBillItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <ValueWithEdit 
            value={supplyBillItem.nameInBill}
            textTooltip={'Редагувати'}
            setOpen={setOpen}
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування назви з рахунку'}
            disableClickOutside={true}
            content={
                <ChangeNameInBillForm
                    supplyBillItemBd={supplyBillItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeNameInBillButton